import clsx from 'clsx';
import InterviewActionsCombobox from 'components/comboboxes/InterviewActionsCombobox';
import MutedText from 'components/common/MutedText';
import { HubertButton } from 'components/HubertUI/HubertButton';
import HubertLabel from 'components/HubertUI/HubertLabel';
import { useTemplateId } from 'hooks/useTemplate';
import { Trash2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from 'rtk/query/hooks';
import { selectQuestionIsReadonly, selectQuestionLanguage, selectQuestionMode } from 'rtk/questionEditorSelector';
import { ECreateQuestionMode, useQuestionEditorContext } from '../context/create-question.context';

import { updatePreActions } from 'rtk/Question.Editor.Slice';
import { customParametersUpdate } from 'rtk/TemplateSlice';
import { EEventType } from 'types/events.enum';

const PreQuestionActions = () => {
  const { t } = useTranslation('Questionsv2');
  const dispatch = useAppDispatch();
  const { questionId } = useQuestionEditorContext();
  const mode = useAppSelector((state) => selectQuestionMode(state, questionId));
  const isReadOnly = useAppSelector((state) => selectQuestionIsReadonly(state, questionId));
  const templateId = useTemplateId();
  const questionLanguage = useAppSelector((state) => selectQuestionLanguage(state, questionId));
  const preActions = useAppSelector(
    (state) =>
      state.Template?.present?.c?.parameters?.[questionId]?.pre_actions ??
      state.questionEditor.byId[questionId]?.pre_actions,
  );

  const updatePreActionHelper = (x: string[]) => {
    if (templateId && mode === ECreateQuestionMode.InTemplateEdit) {
      dispatch(
        customParametersUpdate({
          templateId,
          resource: {
            nodeId: questionId,
            key: 'pre_actions',
            value: x,
            language: questionLanguage,
            isDefault: false,
          },
          eventType: EEventType.ADDED,
          description: `User set custom pre_actions for ${questionId}.`,
        }),
      );
    } else {
      dispatch(updatePreActions({ questionId, actions: x }));
    }
  };

  return (
    <div
      className={clsx(
        // mode === ECreateQuestionMode.InTemplateEdit && 'hidden',
        'flex flex-col justify-start gap-4',
        'p-1',
      )}
    >
      <div className={clsx('flex flex-row justify-start gap-4', 'hubert-vertical-center')}>
        <HubertLabel className="cursor-pointer text-sm font-medium" htmlFor="create-question-text">
          {t('preActions.label')}
        </HubertLabel>

        <HubertButton
          size="xs"
          onClick={() => {
            const x = [...(preActions || [])];
            x.push('');
            updatePreActionHelper(x);
          }}
        >
          {t('preActions.addAction')}
        </HubertButton>
      </div>
      <div className="">
        <MutedText text={t('preActions.hint')} />
      </div>

      <div>
        {preActions &&
          preActions.map((action: string, index: number) => {
            return (
              <div
                key={`question-pre-action-${questionId}-${index}`}
                className={clsx(
                  'flex flex-row justify-between',
                  'hubert-vertical-center p-2 pr-4',
                  'hover:bg-primary-50',
                  'rounded-md',
                )}
              >
                <InterviewActionsCombobox
                  id={`create-question-interview-pre-action-${index}`}
                  isMulti={false}
                  onValueChange={(value) => {
                    const x = [...(preActions || [])];
                    x[index] = value as string;
                    updatePreActionHelper(x);
                  }}
                  disabled={isReadOnly}
                  value={action}
                />

                <Trash2
                  className="text-danger-400 cursor-pointer"
                  onClick={() => {
                    const x = [...(preActions || [])];
                    x.splice(index, 1);
                    updatePreActionHelper(x);
                  }}
                />
              </div>
            );
          })}
      </div>
    </div>
  );
};
export default PreQuestionActions;
